import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { DetailsService } from './details.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'cc-event-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  public title: string;
  public eventId: number;

  constructor(
    public location: Location,
    public detailsService: DetailsService,
    public activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const eventIdBase = location.pathname.split('/');
    this.title = this.activatedRoute.snapshot.data.title;
    this.eventId = parseInt(eventIdBase[eventIdBase.length - 1], 10);

    if (this.eventId) {
      this.detailsService.setEventId(this.eventId);
    }
  }

  back() {
    this.location.back();
  }
}
